/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";
var MethodNotImplementedException = (function () {
    function MethodNotImplementedException() {
    }
    return MethodNotImplementedException;
}());
exports.MethodNotImplementedException = MethodNotImplementedException;



//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/dist/lib/misc/methodNotImplementedException.js
// module id = ./node_modules/ag-grid/dist/lib/misc/methodNotImplementedException.js
// module chunks = 0